import api from "../middlware/api";
import { BASE_URL } from "../constants";

const BASE = `${BASE_URL}/api/v1`;

const toQuery = (params: Record<string, any>) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") q.set(k, String(v));
  });
  return q.toString();
};

export const getInvoiceReport = (params: Record<string, any> = {}) =>
  api.get(`${BASE}/reports/invoices?${toQuery(params)}`);

export const getCollectionsReport = (params: Record<string, any> = {}) =>
  api.get(`${BASE}/reports/collections?${toQuery(params)}`);

export const getOutstandingReport = (params: Record<string, any> = {}) =>
  api.get(`${BASE}/reports/outstanding?${toQuery(params)}`);

export const getVisitReport = (params: Record<string, any> = {}) =>
  api.get(`${BASE}/reports/visits?${toQuery(params)}`);
